import clsx from 'clsx';
import Link from 'next/link';

import Chevron from 'icons/chevron.svg';
import classes from './LabelValueRow.module.css';

export interface LabelValueRowProps {
  bold?: boolean;
  date?: string;
  href?: string;
  icon?: React.ReactNode;
  isFirstInSection?: boolean;
  label: string;
  notifications?: number;
  style?: 'default' | 'transaction';
  subtitle?: string;
  unit?: string;
  value?: React.ReactNode;
}

const LabelValueRow: React.FC<LabelValueRowProps> = ({
  bold,
  date,
  href,
  icon,
  isFirstInSection,
  label,
  notifications,
  style = 'default',
  subtitle,
  unit,
  value,
}) => {
  return (
    <Wrapper
      href={href}
      className={clsx(
        classes.wrapper,
        classes[style],
        isFirstInSection && classes.isFirstInSection,
      )}
    >
      <div className={classes.labelDate}>
        <div className={[classes.label, bold && classes.bold].join(' ')}>{label}</div>
        <div className={classes.subtitle}>{subtitle}</div>
        {date && <div className={classes.date}>{date}</div>}
      </div>

      {notifications && notifications > 0 ? (
        <div className={classes.notifications}>{notifications}</div>
      ) : null}

      {(value || unit) && (
        <div className={classes.value}>
          {value}
          {unit ? ` ${unit}` : null}
        </div>
      )}

      {icon}

      {href && (
        <div className={classes.chevron}>
          <Chevron />
        </div>
      )}
    </Wrapper>
  );
};

export default LabelValueRow;

const Wrapper = ({
  children,
  className,
  href,
}: {
  children: React.ReactNode;
  className?: string;
  href?: string;
}) => {
  return href ? (
    <Link href={href}>
      <a className={className}>{children}</a>
    </Link>
  ) : (
    <span className={className}>{children}</span>
  );
};
